import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

@Component({
  selector: 'app-naplo-listak',
  templateUrl: './listak.component.html',
  styleUrls: ['../naplo-shared.scss', './listak.component.scss'],
})
export class ListakComponent implements OnInit, OnDestroy {
  nezet: 'afa' | 'eredmeny' | 'penzforgalom' | 'rovat' | 'partner' = 'afa';
  /** Készpénz-korlát (Art. 114. §) a partnerösszesítőn: a havi legnagyobb kifizetés a sávban. */
  honapNev(ho: number | null) { return ho ? this.honapok[ho - 1] : ''; }
  kpSzazalek(p: any) { return Math.min(100, Math.round((Number(p.kp_max) || 0) / (Number(p.kp_korlat) || 1500000) * 100)); }
  afa: any = null;
  eredmeny: any = null;
  penzforgalom: any = null;
  rovat: any[] = [];
  partner: any[] = [];
  honapok = ['Jan', 'Feb', 'Már', 'Ápr', 'Máj', 'Jún', 'Júl', 'Aug', 'Sze', 'Okt', 'Nov', 'Dec'];

  constructor(private naplo: NaploService, private toast: ToastController, private router: Router, private route: ActivatedRoute) {}
  private qSub?: Subscription;

  /*  A kimutatást a főmenü választja ki (`?nezet=afa` …), a fül-sor ugyanezt állítja. Kettős
   *  könyvelésnél az eredmény és az ÁFA a főkönyvből jön (kettos), a többi egyszeres-specifikus. */
  static readonly FULEK: { k: ListakComponent['nezet']; c: string }[] = [
    { k: 'eredmeny', c: 'Eredménykimutatás' }, { k: 'afa', c: 'ÁFA-analitika' }, { k: 'penzforgalom', c: 'Pénzforgalom' },
    { k: 'rovat', c: 'Rovatanalitika' }, { k: 'partner', c: 'Partnerösszesítő' },
  ];
  fulek = ListakComponent.FULEK;
  fulValt(k: string) { this.router.navigate([], { relativeTo: this.route, queryParams: { nezet: k } }); }

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    this.qSub = this.route.queryParamMap.subscribe(async (q) => {
      const n = q.get('nezet') || 'eredmeny';
      if (this.aktiv.konyveles_mod === 'kettos') {
        this.router.navigate(['/naplo/kettos'], { queryParams: { nezet: n === 'afa' ? 'afa' : 'eredmeny' }, replaceUrl: true });
        return;
      }
      if (this.aktiv.ugyfelId) await this.valt(this.fulek.some((f) => f.k === n) ? n : 'eredmeny');
    });
  }
  ngOnDestroy() { this.qSub?.unsubscribe(); }

  async valt(n: any) {
    this.nezet = n;
    try {
      const id = this.aktiv.ugyfelId;
      if (n === 'afa' && !this.afa) this.afa = await this.naplo.get('/afa/' + id + this.naplo.evq());
      if (n === 'eredmeny' && !this.eredmeny) this.eredmeny = await this.naplo.get('/eredmeny/' + id + this.naplo.evq());
      if (n === 'penzforgalom' && !this.penzforgalom) this.penzforgalom = await this.naplo.get('/penzforgalom/' + id + this.naplo.evq());
      if (n === 'rovat' && !this.rovat.length) this.rovat = await this.naplo.get('/rovatanalitika/' + id + this.naplo.evq());
      if (n === 'partner' && !this.partner.length) this.partner = await this.naplo.get('/partnerosszesito/' + id + this.naplo.evq());
    } catch { (await this.toast.create({ message: 'Nem sikerült lekérni az adatokat.', duration: 2500, color: 'danger' })).present(); }
  }
}
